export const LIST_GROW_CON_VIDEO_SLIDER_LOADING =
  "LIST_GROW_CON_VIDEO_SLIDER_LOADING";
export const LIST_GROW_CON_VIDEO_SLIDER_SUCCESS =
  "LIST_GROW_CON_VIDEO_SLIDER_SUCCESS";
export const LIST_GROW_CON_VIDEO_SLIDER_ERROR =
  "LIST_GROW_CON_VIDEO_SLIDER_ERROR";
export const SET_PAYLOAD = "SET_PAYLOAD";
